// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__2J_DN","Wrapper":"style_Wrapper__3_CQN","NBold":"style_NBold__3RKnS"};